import { InfoCircledIcon } from '@radix-ui/react-icons';
import { CommonTooltip } from 'components/common/tooltip';

export const BattersPovIcon = () => (
  <CommonTooltip trigger={<InfoCircledIcon />} text_md="pd.batters-pov" />
);
